module.exports = __webpack_public_path__ + "static/media/jioIcon.2f8cef5b.png";